import React from 'react';
import { useTranslation } from 'react-i18next';
import NoData from '../../components/NoData';

const NoVales = () => {
  const { t } = useTranslation();

  return (
    <NoData>
      <div className="mensaje">
        <p>{t('ahorros.no-records')}</p>
        <p>{t('ahorros.no-records2')}</p>
      </div>
    </NoData>
  );
};

export default NoVales;
